export default __webpack_public_path__ + "static/Promptnow_logo-e5a0e704e082b5aab6f9df6cbf5f8757.png";